// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingIndicator_loading__31l1Y","icon":"LoadingIndicator_icon__skl9i","spin":"LoadingIndicator_spin__3zzWm"};